export const stepEvents: Record<number, string> = {
  1: 'Choosing Cleaning Type',
  2: 'Determining Cleaning Type',
  3: 'Service Recommendation & Upsell',
  4: 'Getting Contact Details',
  5: 'Quote Summary Screen ',
  6: 'Date Selection & Address',
  7: 'Booking Confirmed'
}
